import { logUsage } from 'owa-analytics';
import { format } from 'owa-localize';
import { makePostRequest } from 'owa-ows-gateway';
import type { Todo } from 'owa-todo-types';
import * as trace from 'owa-trace';
import { TODO_API_TASKS_IN_FOLDER_FORMAT, TODO_API_DEFAULT_FOLDER_NAME } from '../utils/constants';
import getPartialTaskFromTodo from '../utils/getPartialTaskFromTodo';
import getTodoRequestHeaders from '../utils/getTodoRequestHeaders';
import { toTodo } from '../utils/toTodo';
import type { CustomData } from 'owa-analytics-types';
import getTodoApiRequestUrl from '../utils/getTodoApiRequestUrl';

/**
 * Calls createItem to create tasks
 * @param todo the item to create
 * @param parentFolderId the id of the folder the new task will live in
 */
export default async function createTaskService(
    todo: Todo,
    parentFolderId: string = null,
    telemetryData: CustomData
): Promise<Todo | null> {
    const folderIdToUse = parentFolderId ? parentFolderId : TODO_API_DEFAULT_FOLDER_NAME;
    const urlTemplate = await getTodoApiRequestUrl(TODO_API_TASKS_IN_FOLDER_FORMAT);
    const url = format(urlTemplate, folderIdToUse);

    const taskToCreate = getPartialTaskFromTodo(todo, true /*ignoreNullValues*/);
    if (!taskToCreate) {
        logUsage('CreateTaskServiceEmptyRequest', telemetryData, { isCore: true });
        return null;
    }

    return makePostRequest(
        url,
        getPartialTaskFromTodo(todo, true /*ignoreNullValues*/),
        null /* correlationId */,
        false /* returnFullResponse */,
        getTodoRequestHeaders() /* customHeaders */,
        undefined /* throwServiceError */,
        undefined /* sendPayloadAsBody */,
        undefined /* includeCredentials */,
        'CREATE_TASK' /* actionName */
    )
        .then((response: any) => {
            return !!response.Id ? toTodo(response) : null;
        })
        .catch(err => {
            trace.errorThatWillCauseAlert('[CreateTaskService] API returned error', err);
            return null;
        });
}
